import { render, staticRenderFns } from "./PromoHome.vue?vue&type=template&id=4048efe9&lang=pug&"
import script from "./PromoHome.vue?vue&type=script&lang=js&"
export * from "./PromoHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports